// extracted by mini-css-extract-plugin
export default {"pageWithHeader":"Modal_pageWithHeader__c5gMB","ant-wave":"Modal_ant-wave__S30RZ","modal":"Modal_modal__PEsvC","open":"Modal_open__n6K4G"};